import { Url } from "./Url.service";
import { HandleResponse, AuthHeader } from "../_helpers";
import { NetworkService } from "./Network.service";
import { AuthenticationService } from "./Authentication.service";

//servicios paraa lo relacion con solo párametros , esto se engloba como analisis
export const InventarioService = {
  //definiciones
  crearProducto,
  crearProductoKipit,
  actualizarProductoKipit,
  listarMantenimientoProductos,
  listarTiendaProductos,
  eliminarProducto,
  obtenerProducto,
  obtenerProductoMantenimiento,
  listarComboAgrupadores,
  aprobacionprecios,
  listarSubCategoriasTienda,
  listarCategoriasTienda,
  listarMasVistos,
  listarMasRecientes,
  listarMasVistosSubCategoria,
  listarMasRecientesSubCategoria,
  listarCat,
  listarProductos,
  filtrarProductos,
  listarPublicProductos,
  crearListaDeseos,
  obtenerListaDeseos,
  EliminarProductoLista,
  crearVarios,
  listarRelacionados,
  deseosCarroCompra,
  crearCategoria,
  eliminarCategoria,
  obtenerCategoria,
  actualizarCategoria,
  obtenerCategoriaNombre,
  obtenerColeccionNombre,
  listarRuta,
  cargaMasivaProducto,
  inactivarProductos,
  activarProductos,
  actualizarEstadoProductos,
  listarColores,
  listarProductoAgrupador,
  obtenerProductoPublic,
  getNombreCategoria,
  productResult,
  productosBusqueda,
  listarMasVendidos,
  listarCategoriaMantenimiento,
  cambiarEstadoCategoria,
  listarTags,
  updateMasivaProducto,
  listarColecciones,
  llenarComboMarca,
  listarDimensiones,
  cambiarEstadoDimesion,
  crearDimension,
  obtenerDimensionEditar,
  actualizarDimension,
  eliminarDimension,
  cambiarEstadoColeccion,
  Crearcoleccion,
  actualizarcole,
  eliminarColeciones,
  ColeccionEditar,
  listarCategoriasMenu,

  listarProductosActivos,
  getCategoriasPanel,
  savePanelProductos,
  removePanelProducto,
  listarKipigreen,
  // ListarCategoriasV2,
  CargaMasivaProductosPrecios,
  ValidarExcelProductosPrecios,
  DescargarPlantillaProductosPrecios,
  InstruccionesCargaMasivaProductosPrecios,
  ExportarExcelProductosPrecios,

  crearBanner,
  actualizarBanner,
  listarBanners,
  eliminarBanner,
  filtraBanner,
  subirImagenBanner,
  crearMarcaAliada,
  actualizarMarcaAliada,
  listarMarcasAliadas,
  obtenerMarcasAliadasHome,
  eliminarMarcaAliada,
  filtrarMarcasAliadas,
  subirImagenMarca,
  filtrarTodosLosProductos,

  filtrarProductosMultiempresa,
  crearProductoMultiempresa,
  actualizarProductoMultiempresa,
  eliminarProductoMultiempresa,
  DescargarPlantillaProductosPreciosMultiempresa,
  CargaMasivaProductosPreciosMultiempresa,
  ValidarExcelProductosPreciosMultiempresa,
  InstruccionesCargaMasivaProductosPreciosMultiempresa,
  ExportarExcelProductosPreciosMultiempresa,
  imagenes_productos,
  listar_productos_bodegas,
  obtener_producto_bodega,
  filtrar_productos_bodegas,
  crear_producto_bodega,
  actualizar_producto_bodega,
  eliminar_producto_bodega,
  listar_bodegas,
  filtrar_bodegas,
  crear_bodega,
  actualizar_bodega,
  eliminar_bodega,


  listarCategoriaMultiempresa,
  obtenerCategoriaEmpresaNombre,
  obtenerCategoriaEmpresa,
  crearCategoriaEmpresa,
  actualizarCategoriaEmpresa,
  eliminarCategoriaEmpresa,
  cambiarEstadoCategoriaEmpresa,
  obtenerCategoriasModuloEmpresa,
  listaRutasCategoriasMultiempresa,

  listarMarcasAliadasEmpresas,
  listarMarcasAliadasEmpresasHome,
  filtrarMarcasAliadasEmpresas,
  crearMarcaAliadaEmpresas,
  actualizarMarcaAliadaEmpresas,

  crear_agrupacion,
  actualizar_agrupacion,
  eliminar_agrupacion,
  listar_agrupaciones,
  obtener_agrupacion,
  filtrar_agrupaciones,
  crear_grupo_productos,
  actualizar_grupo_productos,
  listar_grupo_productos,
  eliminar_grupo_productos,
  obtener_grupo_productos,
};

function listar_bodegas() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}bodegas_producto/listar_bodegas`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
};

function filtrar_bodegas(filtros = {}) {
  if (typeof filtros === "string") {
    filtros = Object.fromEntries(new URLSearchParams(filtros));
  }

  const params = new URLSearchParams();

  if (filtros.nombre_bodega) {
    params.append('nombre_bodega', filtros.nombre_bodega);
  }

  if (filtros.codigo_bodega) {
    params.append('codigo_bodega', filtros.codigo_bodega);
  }

  if (filtros.id_empresa !== undefined && filtros.id_empresa !== null && filtros.id_empresa !== '') {
    params.append('id_empresa', filtros.id_empresa);
  }

  const queryString = params.toString();
  const url = `${Url}bodegas_producto/filtrar_bodegas${queryString ? '?' + queryString : ''}`;

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listar_productos_bodegas() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}bodegas_producto/listar_productos_bodegas`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
};

function obtener_producto_bodega(id) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };
  return fetch(`${Url}bodegas_producto/obtener_producto_bodega/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function filtrar_productos_bodegas(filtros = {}) {
  if (typeof filtros === "string") {
    filtros = Object.fromEntries(new URLSearchParams(filtros));
  }

  const params = new URLSearchParams();

  if (filtros.page) {
    params.append('page', filtros.page);
  }

  if (filtros.per_page) {
    params.append('per_page', filtros.per_page);
  }

  if (filtros.id_producto !== undefined && filtros.id_producto !== null && filtros.id_producto !== '') {
    params.append('id_producto', filtros.id_producto);
  }

  if (filtros.estado && ['A', 'I'].includes(filtros.estado)) {
    params.append('estado', filtros.estado);
  }

  if (filtros.id_bodega !== undefined && filtros.id_bodega !== null && filtros.id_bodega !== '') {
    params.append('id_bodega', filtros.id_bodega);
  }

  if (filtros.stock_ingreso !== undefined && filtros.stock_ingreso !== null && filtros.stock_ingreso !== '') {
    params.append('stock_ingreso', filtros.stock_ingreso);
  }

  if (filtros.stock_salida !== undefined && filtros.stock_salida !== null && filtros.stock_salida !== '') {
    params.append('stock_salida', filtros.stock_salida);
  }

  if (filtros.stock_actual !== undefined && filtros.stock_actual !== null && filtros.stock_actual !== '') {
    params.append('stock_actual', filtros.stock_actual);
  }

  const queryString = params.toString();
  const url = `${Url}bodegas_producto/filtrar_productos_bodegas${queryString ? '?' + queryString : ''}`;

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function crear_producto_bodega(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}bodegas_producto/crear_producto_bodega`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizar_producto_bodega(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}bodegas_producto/actualizar_producto_bodega/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminar_producto_bodega(id, data) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}bodegas_producto/eliminar_producto_bodega/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function crear_bodega(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}bodegas_producto/crear_bodega`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizar_bodega(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}bodegas_producto/actualizar_bodega/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminar_bodega(id, data) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
  };
  return fetch(`${Url}bodegas_producto/eliminar_bodega/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}





function listarColecciones() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}inventario/listarColecciones`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function obtenerColeccionNombre(nombre) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(nombre),
  };
  return fetch(`${Url}inventario/filtrarColeccion`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function cambiarEstadoColeccion(id_coleccion, estado) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify({}),
  };

  return fetch(`${Url}inventario/cambiarEstadoColeccion/${id_coleccion}/${estado}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      // console.log(response)
      return response;
    });

};



function listarTags() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}inventario/listarTags`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function listarCat() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}inventario/listarCategoria`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function listarProductos() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}inventario/listarProductos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function filtrarProductos(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/filtrarProductos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function productResult(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/productResult`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};



function listarCategoriasTienda(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/listarCategoriasTienda`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function listarCategoriasMenu(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/listarCategoriasMenu`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function listarSubCategoriasTienda(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/listarSubCategoriasTienda`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function listarMasVistosSubCategoria(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/listarMasVistosSubCategoria`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};


function listarMasRecientesSubCategoria(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/listarMasRecientesSubCategoria`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function listarMasVistos(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/listarMasVistos?${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarMasVendidos(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/listarMasVendidos?${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}



function getNombreCategoria(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/getCategoriaNombre/${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarMasRecientes(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify({ estado: data }),
  };
  return fetch(`${Url}inventario/listarMasRecientes?${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarTiendaProductos(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify({ estado: data }),
  };
  return fetch(`${Url}inventario/listarTiendaProductos?${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarPublicProductos(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify({ estado: data }),
  };
  return fetch(`${Url}inventario/listarPublicProductos?${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function productosBusqueda(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify({ estado: data }),
  };
  return fetch(`${Url}inventario/productosBusqueda?${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarMantenimientoProductos(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify({ estado: data }),
  };
  return fetch(`${Url}inventario/listarMantenimientoProductos?${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function obtenerProducto(id_producto) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };
  return fetch(`${Url}inventario/obtenerProducto/${id_producto}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function obtenerProductoMantenimiento(id_producto) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };
  return fetch(`${Url}inventario/obtenerProductoMantenimiento/${id_producto}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function obtenerProductoPublic(id_producto) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };
  return fetch(`${Url}inventario/obtenerProductoPublic/${id_producto}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarComboAgrupadores(agrupador) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };
  return fetch(`${Url}inventario/listarComboAgrupadores?${agrupador}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function crearProductoKipit(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/crearProductoKipit`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function aprobacionprecios(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/aprobacionprecios`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarProductoKipit(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/actualizarProductoKipit`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function crearProducto(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/crearProducto`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function eliminarProducto(data) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/eliminarProducto`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}
function crearCategoria(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/crearCategoria`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}
function eliminarCategoria(data) {
  // debugger;
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
    // body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/eliminarCategoria/${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function crearListaDeseos(data) {
  // console.log(data);
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({ data }),
  };
  return fetch(`${Url}inventario/crearListaDeseos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      // console.log('response');
      // console.log(response);
      return response;
    });
}

function obtenerListaDeseos(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };
  return fetch(`${Url}inventario/obtenerListaDeseos?${data}`, requestOptions)

    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}
function obtenerCategoria(id_categoria) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}inventario/obtenerCategoria/${id_categoria}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function obtenerColeccion(id_coleccion) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}inventario/obtenerColeccion/${id_coleccion}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function EliminarProductoLista(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({ data }),
  };
  return fetch(`${Url}inventario/EliminarProductoLista`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarCategoria(data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/actualizarCategoria`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function crearVarios(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({ "productos": data }),
  };
  return fetch(`${Url}inventario/crearVarios`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      // console.log('response');
      // console.log(response);
      return response;
    });
}

function listarRelacionados(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({ data }),
  };
  return fetch(`${Url}inventario/listarRelacionados`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function deseosCarroCompra(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/deseosCarroCompra`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function obtenerCategoriaNombre(nombre) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(nombre),
  };
  return fetch(`${Url}inventario/filtrarCategoria`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}
function listarRuta() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify(nombre),
  };
  return fetch(`${Url}inventario/listaRuta`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function cargaMasivaProducto(file) {//
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(null),
    body: file,

  };
  // console.log(file)
  return fetch(`${Url}inventario/cargaMasivaProducto`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function CargaMasivaProductosPrecios(file) {//
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(null),
    body: file,

  };
  // console.log(file)
  return fetch(`${Url}productos-precios/cargar`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function DescargarPlantillaProductosPrecios() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify(nombre),
  };
  return fetch(`${Url}productos-precios/descargar-plantilla`, requestOptions)
    .then(async (response) => {
      if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
          AuthenticationService.logout();
          window.location.reload(true);
        }
        const text = await response.text();
        let error = response.statusText;
        try {
          const data = text && JSON.parse(text);
          error = (data && data?.text?.message) || error;
        } catch (parseError) {
          // Ignore JSON parse errors for non-JSON responses.
        }
        return Promise.reject(error);
      }

      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const text = await response.text();
        return text ? JSON.parse(text) : {};
      }

      return response.blob();
    });
}

function ValidarExcelProductosPrecios(file) {//
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(null),
    body: file,

  };
  // console.log(file)
  return fetch(`${Url}productos-precios/validar`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function InstruccionesCargaMasivaProductosPrecios() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify(nombre),
  };
  return fetch(`${Url}productos-precios/instrucciones`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function ExportarExcelProductosPrecios(filtros = {}) {
  // Construir query params desde los filtros
  const params = new URLSearchParams();

  // Agregar todos los filtros que tengan valor
  if (filtros.proveedor) {
    params.append('proveedor', filtros.proveedor);
  }

  if (filtros.estado) {
    const estados = Array.isArray(filtros.estado) ? filtros.estado : [filtros.estado];
    const estadosValidos = estados.filter(e => ['A', 'I'].includes(e));
    estadosValidos.forEach(e => params.append('estado[]', e));
  }

  if (filtros.nombre) {
    params.append('nombre', filtros.nombre);
  }

  if (filtros.codigo_producto) {
    params.append('codigo_producto', filtros.codigo_producto);
  }

  if (filtros.ruc) {
    params.append('ruc', filtros.ruc);
  }

  if (filtros.categoria) {
    params.append('categoria', filtros.categoria);
  }

  if (filtros.subcategoria) {
    params.append('subcategoria', filtros.subcategoria);
  }

  if (filtros.fecha_inicio) {
    params.append('fecha_inicio', filtros.fecha_inicio);
  }

  if (filtros.fecha_fin) {
    params.append('fecha_fin', filtros.fecha_fin);
  }

  if (filtros.estado_imagen !== undefined && filtros.estado_imagen !== null && filtros.estado_imagen !== '') {
    params.append('estado_imagen', filtros.estado_imagen);
  }

  const queryString = params.toString();
  const url = `${Url}productos-precios/exportar${queryString ? '?' + queryString : ''}`;

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(url, requestOptions)
    .then(async (response) => {
      if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
          AuthenticationService.logout();
          window.location.reload(true);
        }
        const text = await response.text();
        let error = response.statusText;
        try {
          const data = text && JSON.parse(text);
          error = (data && data?.text?.message) || error;
        } catch (parseError) {
          // Ignore JSON parse errors for non-JSON responses.
        }
        return Promise.reject(error);
      }

      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const text = await response.text();
        return text ? JSON.parse(text) : {};
      }

      return response.blob();
    });
}

function inactivarProductos(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({
      "lista": data
    })

  };
  // console.log(data)
  return fetch(`${Url}inventario/inactivarProductos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function activarProductos(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({
      "lista": data
    })
  };

  return fetch(`${Url}inventario/activarProductos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function actualizarEstadoProductos(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({
      "lista": data
    })

  };
  // console.log(data)
  return fetch(`${Url}inventario/actualizarEstadoProductos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarColores() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };
  return fetch(`${Url}inventario/listaColores`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarProductoAgrupador() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };
  return fetch(`${Url}inventario/listarProductoAgrupador`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}
function listarCategoriaMantenimiento() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}inventario/listarCategoriaMantenimiento`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};
function cambiarEstadoCategoria(id, estado) {
  // debugger;

  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    // body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/cambiarEstadoCategoria/${id}/${estado}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}
function updateMasivaProducto(file) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(null),
    body: file,

  };
  // console.log(file)
  return fetch(`${Url}inventario/updateMasivoProducto`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}
function llenarComboMarca() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //  body: file,

  };

  return fetch(`${Url}inventario/comboMarcas`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function listarDimensiones() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}inventario/listarDimensiones`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function cambiarEstadoDimesion(id, estado) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    // body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/cambiarEstadoDimesion/${id}/${estado}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function eliminarDimension(data) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
  };
  return fetch(`${Url}inventario/eliminarDimension/${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}



function crearDimension(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/crearDimension`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function obtenerDimensionEditar(id_dimesion_producto) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}inventario/obtenerDimensionEditar/${id_dimesion_producto}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarDimension(data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/actualizarDimension`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

//colecciones

function Crearcoleccion(data) {
  const requestOptions = {
    method: "post",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/Crearcoleccion`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarcole(data) {
  const requestOptions = {
    method: "post",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/actualizarcole`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminarColeciones(id) {
  // debugger;
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(id),
  };
  return fetch(`${Url}inventario/eliminarColecion/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function ColeccionEditar(data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/ColeccionEditar`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function getCategoriasPanel(tipoNegocioActiva, pestanaActiva) {
  const data = {
    negocio: tipoNegocioActiva,
    pestania: pestanaActiva
  };
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/getCategoriasPanel`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarProductosActivos(categoria, tipoNegocio, pestanaActiva) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({ categoria, tipoNegocio, pestanaActiva }),
  };

  return fetch(`${Url}inventario/getProductosActivados`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      // console.log(response)
      return response;
    });
}

function savePanelProductos(categoria, tipoNegocio, pestanaActiva, nuevosProductosSeleccionados) {

  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({ categoria, tipoNegocio, pestanaActiva, nuevosProductosSeleccionados }),
  };

  return fetch(`${Url}inventario/savePanelProductos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function removePanelProducto(idProducto, idTipoPagina, idPestania) {

  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify({ idProducto, idTipoPagina, idPestania }),
  };

  return fetch(`${Url}inventario/removePanelProducto`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}
function listarKipigreen(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify({ estado: data }),
  };
  return fetch(`${Url}inventario/listarKipigreen?${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

// function ListarCategoriasV2() {
//   const requestOptions = {
//     method: "GET",
//     headers: AuthHeader(),
//     //body: JSON.stringify( data ),
//   };

//   return fetch(`${Url}inventario/listarCategoriasV2`, requestOptions)
//     .then(HandleResponse)
//     .then((response) => {
//       return response;
//     });
// }

function crearBanner(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}banners/crear_banner`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarBanner(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}banners/actualizar_banner/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarBanners(params = {}) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  // Construir query params
  const queryParams = new URLSearchParams();
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      queryParams.append(key, params[key]);
    }
  });

  const queryString = queryParams.toString();
  const url = `${Url}banners/listar_banners${queryString ? '?' + queryString : ''}`;

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminarBanner(id) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
  };

  return fetch(`${Url}banners/eliminar_banner/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function filtraBanner(params = {}) {

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  const queryParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {

    if (
      params[key] !== undefined &&
      params[key] !== null &&
      params[key] !== ""
    ) {
      queryParams.append(key, params[key]);
    }

  });

  const queryString = queryParams.toString();

  const url = `${Url}banners/filtrar_banners${queryString ? "?" + queryString : ""
    }`;

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

}

function subirImagenBanner(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(null),
    body: data,
  };

  return fetch(`${Url}banners/subir_imagen`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function crearMarcaAliada(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}marcas_aliadas/crear_marca_aliada`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarMarcaAliada(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}marcas_aliadas/actualizar_marca_aliada/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listarMarcasAliadas(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.per_page) queryParams.append("per_page", params.per_page);
  if (params.estado) queryParams.append("estado", params.estado);
  if (params.sistema_id) queryParams.append("sistema_id", params.sistema_id);
  if (params.nombre_marca) queryParams.append("nombre_marca", params.nombre_marca);
  if (params.id_marca_aliada) queryParams.append("id_marca_aliada", params.id_marca_aliada);
  if (params.id_empresa) queryParams.append("id_empresa", params.id_empresa);
  if (params.visible_kipit) queryParams.append("visible_kipit", params.visible_kipit);

  const queryString = queryParams.toString();
  const url = `${Url}marcas_aliadas/listar_marcas_aliadas${queryString ? "?" + queryString : ""}`;

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}


function obtenerMarcasAliadasHome(params = {}) {
  const queryParams = new URLSearchParams();


  if (params.estado) queryParams.append("estado", params.estado);
  if (params.sistema_id) queryParams.append("sistema_id", params.sistema_id);
  if (params.nombre_marca) queryParams.append("nombre_marca", params.nombre_marca);
  if (params.id_marca_aliada) queryParams.append("id_marca_aliada", params.id_marca_aliada);
  if (params.id_empresa) queryParams.append("id_empresa", params.id_empresa);
  if (params.visible_kipit) queryParams.append("visible_kipit", params.visible_kipit);

  const queryString = queryParams.toString();
  const url = `${Url}marcas_aliadas/home${queryString ? "?" + queryString : ""}`;

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminarMarcaAliada(id) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
  };

  return fetch(`${Url}marcas_aliadas/inactivar_marca_aliada/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function filtrarMarcasAliadas(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  const queryParams = new URLSearchParams();
  Object.keys(data).forEach((key) => {
    if (
      data[key] !== undefined &&
      data[key] !== null &&
      data[key] !== ""
    ) {
      queryParams.append(key, data[key]);
    }
  });

  const queryString = queryParams.toString();
  const url = `${Url}marcas_aliadas/filtrar_marcas_aliadas${queryString ? "?" + queryString : ""}`;

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function subirImagenMarca(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(null),
    body: data,
  };

  return fetch(`${Url}marcas_aliadas/subir_imagen`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function filtrarTodosLosProductos(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/filtrarTodosLosProductos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};


/* Multiempresa*/

/**
 * Productos
 */

function filtrarProductosMultiempresa(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}inventario/filtrarProductosMultiempresa`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function crearProductoMultiempresa(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/crearProductoMultiempresa`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarProductoMultiempresa(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/ActualizarProductoMultiempresa`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminarProductoMultiempresa(data) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}inventario/eliminarProductoMultiempresa`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}



function CargaMasivaProductosPreciosMultiempresa(file) {//
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(null),
    body: file,

  };
  // console.log(file)
  return fetch(`${Url}productos-precios/cargar-multiempresa`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}



function DescargarPlantillaProductosPreciosMultiempresa() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify(nombre),
  };
  return fetch(`${Url}productos-precios/descargar-plantilla-multiempresa`, requestOptions)
    .then(async (response) => {
      if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
          AuthenticationService.logout();
          window.location.reload(true);
        }
        const text = await response.text();
        let error = response.statusText;
        try {
          const data = text && JSON.parse(text);
          error = (data && data?.text?.message) || error;
        } catch (parseError) {
          // Ignore JSON parse errors for non-JSON responses.
        }
        return Promise.reject(error);
      }

      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const text = await response.text();
        return text ? JSON.parse(text) : {};
      }

      return response.blob();
    });
}

function ValidarExcelProductosPreciosMultiempresa(file) {//
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(null),
    body: file,

  };
  // console.log(file)
  return fetch(`${Url}productos-precios/validar-multiempresa`, requestOptions)
    .then(async (response) => {
      try {
        const data = await response.json();

        if (!response.ok && !data.message) {
          throw new Error(response.statusText);
        }
        return data;
      } catch (error) {
        throw new Error(response.statusText);
      }
    });
}

function InstruccionesCargaMasivaProductosPreciosMultiempresa() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify(nombre),
  };
  return fetch(`${Url}productos-precios/instrucciones-multiempresa`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function ExportarExcelProductosPreciosMultiempresa(filtros = {}) {
  // Construir query params desde los filtros
  const params = new URLSearchParams();

  // Agregar todos los filtros que tengan valor
  if (filtros.proveedor) {
    params.append('proveedor', filtros.proveedor);
  }

  if (filtros.estado) {
    const estados = Array.isArray(filtros.estado) ? filtros.estado : [filtros.estado];
    estados
      .filter((e) => ['A', 'I'].includes(e))
      .forEach((e) => params.append('estado[]', e));
  }

  if (filtros.nombre) {
    params.append('nombre', filtros.nombre);
  }

  if (filtros.codigo_producto) {
    params.append('codigo_producto', filtros.codigo_producto);
  }

  if (filtros.ruc) {
    params.append('ruc', filtros.ruc);
  }

  if (filtros.categoria) {
    params.append('categoria', filtros.categoria);
  }

  if (filtros.subcategoria) {
    params.append('subcategoria', filtros.subcategoria);
  }

  if (filtros.fecha_inicio) {
    params.append('fecha_inicio', filtros.fecha_inicio);
  }

  if (filtros.fecha_fin) {
    params.append('fecha_fin', filtros.fecha_fin);
  }

  if (filtros.estado_imagen !== undefined && filtros.estado_imagen !== null && filtros.estado_imagen !== '') {
    params.append('estado_imagen', filtros.estado_imagen);
  }

  const queryString = params.toString();
  const url = `${Url}productos-precios/exportar-multiempresa${queryString ? '?' + queryString : ''}`;

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(url, requestOptions)
    .then(async (response) => {
      if (!response.ok) {
        if ([401, 403].indexOf(response.status) !== -1) {
          AuthenticationService.logout();
          window.location.reload(true);
        }
        const text = await response.text();
        let error = response.statusText;
        try {
          const data = text && JSON.parse(text);
          error = (data && data?.text?.message) || error;
        } catch (parseError) {
          // Ignore JSON parse errors for non-JSON responses.
        }
        return Promise.reject(error);
      }

      const contentType = response.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const text = await response.text();
        return text ? JSON.parse(text) : {};
      }

      return response.blob();
    });
}

function imagenes_productos(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}producto/imagenes_productos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
};


/**
 * categorias
 */
function listarCategoriaMultiempresa() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}Modulo/ListarCategoriasModulo`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function obtenerCategoriaEmpresaNombre(nombre) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(nombre),
  };
  return fetch(`${Url}Modulo/FiltrarCategoriasEmpresas`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function obtenerCategoriaEmpresa(id_categoria) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}Modulo/obtenerCategoriaEmpresa/${id_categoria}`, requestOptions)
    .then(HandleResponse);
}

function crearCategoriaEmpresa(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}Modulo/crearCategoriaEmpresa`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarCategoriaEmpresa(data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };
  return fetch(`${Url}Modulo/actualizarCategoriaEmpresa`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminarCategoriaEmpresa(data) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
    // body: JSON.stringify(data),
  };
  return fetch(`${Url}Modulo/eliminarCategoriaEmpresa/${data}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function cambiarEstadoCategoriaEmpresa(id, estado) {
  // debugger;

  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    // body: JSON.stringify(data),
  };
  return fetch(`${Url}Modulo/cambiarEstadoCategoriaEmpresa/${id}/${estado}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function obtenerCategoriasModuloEmpresa() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    //body: JSON.stringify( data ),
  };

  return fetch(`${Url}Modulo/listarCategoriasModulo`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });

};

function listaRutasCategoriasMultiempresa() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
    // body: JSON.stringify(nombre),
  };
  return fetch(`${Url}Modulo/listaRuta`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

//Marcas aliadas
function listarMarcasAliadasEmpresas(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.per_page) queryParams.append("per_page", params.per_page);
  if (params.estado) queryParams.append("estado", params.estado);
  if (params.sistema_id) queryParams.append("sistema_id", params.sistema_id);
  if (params.nombre_marca) queryParams.append("nombre_marca", params.nombre_marca);
  if (params.id_marca_aliada) queryParams.append("id_marca_aliada", params.id_marca_aliada);
  if (params.id_empresa) queryParams.append("id_empresa", params.id_empresa);

  const queryString = queryParams.toString();
  const url = `${Url}marcas_aliadas/listar_marcas_aliadas_empresas${queryString ? "?" + queryString : ""}`;

  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

async function listarMarcasAliadasEmpresasHome(idEmpresa) {
  if (!idEmpresa) throw new Error("idEmpresa es requerido");

  const requestOptions = { method: "GET" };

  return fetch(`${Url}marcas_aliadas/marcas-aliadas-home/${encodeURIComponent(idEmpresa)}`, requestOptions)
    .then(HandleResponse);
}

function filtrarMarcasAliadasEmpresas(data) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  const queryParams = new URLSearchParams();
  Object.keys(data).forEach((key) => {
    if (
      data[key] !== undefined &&
      data[key] !== null &&
      data[key] !== ""
    ) {
      queryParams.append(key, data[key]);
    }
  });

  const queryString = queryParams.toString();
  const url = `${Url}marcas_aliadas/filtrar_marcas_aliadas_empresas${queryString ? "?" + queryString : ""}`;

  return fetch(url, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function crearMarcaAliadaEmpresas(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}marcas_aliadas/crear_marca_aliada_empresas`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizarMarcaAliadaEmpresas(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}marcas_aliadas/actualizar_marca_aliada_empresas/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function crear_agrupacion(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}grupo_producto/crear_agrupacion`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizar_agrupacion(id, data) {
  const requestOptions = {
    method: "PUT",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}grupo_producto/actualizar_agrupacion/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listar_agrupaciones() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}grupo_producto/listar_agrupaciones`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function obtener_agrupacion(id_producto) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}grupo_producto/obtener_agrupacion/${id_producto}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminar_agrupacion(id) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
  };

  return fetch(`${Url}grupo_producto/eliminar_agrupacion/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function filtrar_agrupaciones(descripcion) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(
    `${Url}grupo_producto/filtrar_agrupaciones?descripcion=${encodeURIComponent(descripcion)}`,
    requestOptions
  )
    .then(HandleResponse)
    .then((response) => response);
}

function crear_grupo_productos(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}grupo_producto/crear_agrupacion_producto`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function actualizar_grupo_productos(data) {
  const requestOptions = {
    method: "POST",
    headers: AuthHeader(),
    body: JSON.stringify(data),
  };

  return fetch(`${Url}grupo_producto/actualizar_agrupacion_producto`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function listar_grupo_productos() {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}grupo_producto/listar_agrupaciones_productos`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function obtener_grupo_productos(id_producto) {
  const requestOptions = {
    method: "GET",
    headers: AuthHeader(),
  };

  return fetch(`${Url}grupo_producto/obtener_agrupacion_producto/${id_producto}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}

function eliminar_grupo_productos(id) {
  const requestOptions = {
    method: "DELETE",
    headers: AuthHeader(),
  };

  return fetch(`${Url}grupo_producto/eliminar_agrupacion_producto/${id}`, requestOptions)
    .then(HandleResponse)
    .then((response) => {
      return response;
    });
}